import React from 'react';
import { AtdwSearch } from './view/atdwSearch';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'AtdwSearch', 
  itemElt: (item, cmsOption) => <AtdwSearch item={item} cmsOption={cmsOption} />
}